/**
 * Recursively drop `undefined` values so payloads are valid for Firestore
 * `updateDoc` / `setDoc` (which reject undefined anywhere in the tree).
 */
export function omitUndefinedDeep<T>(value: T): T {
  return omit(value) as T;
}

function omit(value: unknown): unknown {
  if (value === undefined) return undefined;
  if (value === null || typeof value !== 'object') return value;
  if (value instanceof Date) return value;
  if (Array.isArray(value)) {
    return value.map(omit).filter((item) => item !== undefined);
  }

  const proto = Object.getPrototypeOf(value);
  if (proto !== Object.prototype && proto !== null) {
    return value;
  }

  const result: Record<string, unknown> = {};
  for (const [key, nested] of Object.entries(value as Record<string, unknown>)) {
    if (nested === undefined) continue;
    const cleaned = omit(nested);
    if (cleaned !== undefined) result[key] = cleaned;
  }
  return result;
}
